const generatePayload = (newItems: never, mapper: string) => {
  const map = new Function('newItems', mapper);
  return map(newItems);
};

const addToCard = async (cartItems: never, clientSideMethod: string) => {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-empty-function
  const AsyncFunction = Object.getPrototypeOf(async function () {}).constructor;
  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-call
  const map = new AsyncFunction('cartItems', clientSideMethod);
  return await map(cartItems);
};

export default { addToCard, generatePayload };
